export const NEVYPORADANO = "NEVYPORADANO";
export const VSE = "VSE";
export const VYRAZENO = "VYRAZENO";

const labels = {
    [NEVYPORADANO]: 'Nevypořádané',
    [VSE]: 'Všechny',
    [VYRAZENO]: 'Vyřazené'
};

export const values = [
    NEVYPORADANO,
    VSE,
    VYRAZENO
];

export function getCaption(typ) {
    return labels[typ];
}
